<template>
  <div class="item-table-info-content" v-if="table">
    <div class="item-table-info-title clear-fix" @click="btn">
      <!-- <div class="item-table-info-title-row">
        <div class="item-table-info-title-row-left">
          <span class="item-table-info-title-row-text">访客量:</span>
          <span class="item-table-info-title-row-number">100人</span>
        </div>
        <div class="item-table-info-title-row-right">
          <span class="item-table-info-title-row-text">单</span>          
        </div>
      </div> -->
      <div class="item-table-info-title-row">
        <div class="item-table-info-title-row-left">
          <span class="item-table-info-title-row-text">{{table.upItem}}:</span>
          <span class="item-table-info-title-row-number">
            {{amount}}{{table.company1}}
          </span>     
        </div>
        <div class="item-table-info-title-row-right">
          <span class="item-table-info-title-row-number">{{count}}</span>
          <span class="item-table-info-title-row-text">{{table.company2}}</span>
          <div class="item_rt"></div>
        </div>
        <div class="bg_item" 
             :style="{width:myColor,
             backgroundColor:table.color}"></div>  
      </div>
    </div>
  </div>
</template>

<script>
import Item from "./itemInfo/item.vue";
export default {
  data(){
    return {
      amount:parseFloat(this.table.realAmount).toFixed(2),
      count:this.table.realCount,
      myTotalPrice:this.table.totalPrice
    }
  },
  props:{
    table:{
      type:Object,
      default: () => {
        return {}
      }
    }
  },
  methods:{
    btn(){
      console.log(this.table.realAmount)
    }
  },
  components: {
    Item
  },
  computed:{
    myColor:function(){
      return parseFloat(this.amount / this.myTotalPrice).toFixed(2) * 100 + '%'
    }
  },
  watch:{
    table:{
      handler(val, oldVal) {
        console.log(val,oldVal)
        this.amount = val.realAmount
        this.count = val.realCount
        this.myTotalPric = val.totalPrice
      },
      immediate: true,
    }
  }
};
</script>

<style lang="scss" scoped>
.item-table-info-content {
  margin: 10px 8px 0;
  text-align: left;
  .item-table-info-title {
    position: relative;
    width: 100%;
    .item_rt{
      margin-top:5px;
      float: right;
      border-width: 10px;
      border-style: solid;
      border-color: transparent  transparent transparent #eaeaea;
    }
    .bg_item{
      position:absolute;
      left:0px;
      top:0px;
      width:0%;
      height:100%;
      border-radius: 4px;
      // transition-property: width;
      // transition-duration: 1s;
    }
    .item-table-info-title-row {
      overflow: hidden;
      display: flex;
      font-size: 16px;
      height:30px;
      line-height: 30px;
      border-radius:4px;
      background:#4d4d4d;
      font-family: Source Han Sans CN, Source Han Sans CN-Light;
      font-weight: 300;
      text-align: left;
      color: #eaeaea;
      cursor: pointer;
      //padding-top: 8px;
      .item-table-info-title-row-left {
        position: absolute;
        left:0px;
        top:0px;
        flex: 1;
        //text-align: center;
        padding-left: 10px;
        z-index:10;
        .item-table-info-title-row-content {
          //width: 100%;
          //height: 100%;
          margin: 0 auto;
        }
      }
      .item-table-info-title-row-right {
        position: absolute;
        right:-4px;
        top:0px;
        z-index:10;
        flex: 1;
        height: 30px;
        line-height: 30px;
        text-align: right;
      }
      .item-table-info-title-row-text {
        //float: left;
        margin-right:10px;
      }
      .item-table-info-title-row-number {
        //float: left;
        //margin-left: 20px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        //text-align: left;
        color: #eaeaea;
      }
    }
    // .item-table-info-title-left {
    //   float: left;
    //   text-align: center;
    //   margin-top: 10px;
    //   width: 33%;
    // }
    // .item-table-info-title-right {
    //   margin-top: 10px;
    //   text-align: center;
    //   float: left;
    //   width: 33%;
    // }
  }
}
</style>